module.exports = __webpack_public_path__ + "img/title.93374ad6.png";